<template>
    <v-container>
      <div class="d-flex justify-space-between">
        <h2 color="#6A158E" class="page-heading" v-text="page_title"></h2>
  
        <bread-crumbs :items="breadItems"></bread-crumbs>
      </div>
  
      <div class="nmt-1">
      
              <v-form>
                <v-container>
                  <fieldset>
                    <v-row>
                      <v-col cols="12" sm="6" md="6">
                        <label class="custom-label">UserName</label>
                        <v-text-field v-model="username" label="Name" placeholder="Name" solo></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <label class="custom-label">Full Name</label>
                        <v-text-field v-model="currentName" label="Name" placeholder="Name" solo ></v-text-field>
                      </v-col>
          
                    
          
                      <v-col cols="12">
                        <v-btn color="#6A158E" dark @click="save">Save</v-btn>
                      </v-col>
                    </v-row>
                  </fieldset>
                </v-container>
              </v-form>
          
          
      </div>
    </v-container>
  </template>
  
  <script>
  import BreadCrumbs from "../../../components/BreadCrumbs";
  import UserForm from "../../../components/settings/UserForm";
  export default {
    name: "AddClass",
    components: { UserForm, BreadCrumbs },
    props:{
      id:{
        type:Number,
        default:null,
      }
    },
    data() {
      return {
        page_title: this.$route.meta.title,
        breadItems: [
          {
            text: "Dashboard",
            disabled: false,
            href: "/",
            to: {
              name: "DashBoard"
            }
          },
          {
            text: "Settings",
            disabled: false,
            to: {
              name: "Settings"
            }
          },
          {
            text: "Users",
            disabled: false,
            to: {
              name: "Users"
            }
          },
          {
            text: this.$route.meta.title,
            disabled: true,
            to: {
              name: this.$route.name
            }
          }
        ]
      };
    }
  };
  </script>
  
  <style scoped>
  .page-heading {
    font: 300 22px/26px;
    font-family: "Gotham Narrow";
    color: #6a158e;
  }
  </style>